import type { LucideIcon } from "lucide-react";
import { resolveActionIcon, resolveActionLabel } from "./catalog";
import type {
  ActionLabelContext,
  ObjectActionDefinition,
  ObjectActionGroupKey,
} from "./types";

export function getActionLabel(
  definition: ObjectActionDefinition,
  ctx: ActionLabelContext,
): string {
  return resolveActionLabel(definition, ctx);
}

export function getActionIcon(
  definition: ObjectActionDefinition,
  ctx: ActionLabelContext,
): LucideIcon {
  return resolveActionIcon(definition, ctx);
}

export function groupActionsByCatalogGroup<
  T extends { definition: ObjectActionDefinition },
>(actions: T[]): T[][] {
  const groups: T[][] = [];
  let currentGroup: ObjectActionGroupKey | null = null;
  let bucket: T[] = [];

  for (const action of actions) {
    const group = action.definition.group;
    if (currentGroup !== null && group !== currentGroup) {
      groups.push(bucket);
      bucket = [];
    }
    currentGroup = group;
    bucket.push(action);
  }

  if (bucket.length > 0) {
    groups.push(bucket);
  }

  return groups;
}
